<div class="container-editor w-100">
    <quill-editor [(ngModel)]="editorContent" [bounds]="'self'" [modules]="editorOptions" #editor (onContentChanged)="onContentChanged($event)" (onEditorCreated)="onEditorCreated($event)"></quill-editor>
</div>

